import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';   // 👍 MUI imports come first

import { Outlet } from 'react-router-dom';
import AppAppBar from '../../modules/views/AppAppBar';            // 👍 local imports after
import AppFooter from '../../modules/views/AppFooter';

export default function Frontend({ loading }) {
  // ⭐ Show loader until Router finishes loading
  if (loading) {
    return (
      <Grid
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100vh",
          backgroundColor: "#000",
          zIndex: 99999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress color="inherit" />
      </Grid>
    );
  }

  // ⭐ Render layout normally when loading is done
  return (
    <>
      <AppAppBar />
      <Outlet />
      <AppFooter />
    </>
  );
}